module.exports = __webpack_public_path__ + "img/logo-jersey.07da7ee6.jpeg";